import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translation: {
        pages: {
          switch: {
            title: 'NEXUS',
            homePageIntro: 'Route Management System',
            ingress: 'This is the future nexus application',
            links: {
              traffic: 'To Traffic',
              terminal: 'To Terminal',
              customs: 'To Customs',
            },
            guideLinks: {
              whatIsNew: 'What is New',
              howToGetAccess: 'How to Get Access',
              learnMore: 'Learn More',
            },
          },
          login: {
            intro: ' Please sign-in to see your profile information.',
            login: ' Log in',
          },
          terminal: {
            title: 'Terminal',
            locationTitle: 'Terminal Locations',
            ingress: 'This is for terminal users.',
            selectTerminalTitle: 'Choose your terminal:',
            selectTerminalLocationTitle: 'Choose your terminal location:',
            name: 'Your Terminal is: {{name}}',
          },
          fixedTrafficOverview: {
            title: 'Fixed Traffic Overview for: ',
          },
          traffic: {
            title: 'Traffic',
            ingress: 'This is for traffic users.',
          },
          customs: {
            title: 'Customs',
            ingress: 'This is for customs users.',
          },
          customer: {
            title: 'Customer',
            ingress: 'This is for customer users.',
          },
          reports: {
            title: 'Reports',
            inProgress: 'under construction',
          },
          editPage: {
            title: 'Edit {{card}}',
          },
          addPage: {
            title: 'Add {{item}}',
          },
          createPage: {
            title: 'Create {{card}}',
            details: 'Details',
          },
          documentBank: {
            title: 'Document Bank',
          },
          holidays: {
            addComponentTitle: 'Add deviation date',
            upcomingComponentTitle: 'Planned deviated dates for {{country}}',
            strictlyCancel: 'Strictly cancel / Do not generate',
            addForLocations: 'For selected location only',
          },
          cmr: {
            title: 'CMR',
          },
          truckFillAndTime: {
            title: 'Truck fill and time - {{name}}',
          },
          kpi: {
            title: 'KPI',
          },
          kpiOrdering: {
            title: 'KPI Ordering',
          },
          dashboard: {
            title: 'Dashboard',
          },
          deviations: {
            title: 'Deviations',
          },
          customerDeviations: {
            title: 'Customer Level Deviations',
          },
          template: {
            title: 'Templates - Create New',
            loading: 'Loading template data...',
            createTemplateOld: 'Create Template - Old',
            createTemplateNew: 'Create Template - New',
          },
          legs: {
            title: 'Legs',
            description: 'LegsList',
          },
          cardsNew: {
            title: 'Cards',
            landing: 'Select a card type to manage',
            graphhopperPlaceholder:
              'Map / Graphhopper Integration (Coming Soon)',
            locationDescription:
              'Location based data used to build routes in Nexus.',
            locationBullet1: 'Geolocation',
            locationBullet2: 'Contact information',
            locationBullet3: 'Associated routes',
            locationBullet4: 'Notes',
            locationBullet5: 'Attached files',
            createNew: 'Create NEW',
            importBatch: 'Import BATCH',
            comingSoon: 'Coming Soon',
            assetsTitle: 'Assets',
            assetsDescription:
              'Assets (e.g. vans, trailers, containers) used in transit between locations.',
            railSailAirTitle: 'Rail, Sail & Air',
            railSailAirDescription: 'For use in transit other than road.',
            subcontractorsTitle: 'Subcontractors',
            subcontractorsDescription:
              'The partners we use to help us get the goods between locations.',
            customersTitle: 'Customer',
            customersDescription: 'Customers that send goods with us.',
            goodsServiceTitle: 'Goods / Service',
            goodsServiceDescription: 'Goods types and services provided.',
          },
          cardsOld: {
            title: 'Cards - Old',
          },
          idlePage: {
            title: 'Page Inactive',
            description:
              'This page has been idle for {{time}} hour(s). Please refresh the page to see the latest updates and real-time data.',
            reloadMessage: 'The page will be reloaded in {{time}}.',
            reload: 'Reload',
            wait: 'Wait for {{time}} more minutes',
            pageReloadsIn: 'Page reloads in {{time}} seconds.',
          },
        },
        components: {
          files: 'Files',
          notes: 'Notes',
          contacts: 'Contacts',
        },
        validation: {
          pressEnterToSaveTag: 'Press Enter to save the tag',
          shipmentTagSaveFailed:
            'Unable to save shipment tag. Please try again.',
          atLeastItem: 'Atleast One Item is required',
          atLeastLen: '{{name}} should be at least {{len}} characters',
          atLeastOneDay: 'At least one day needs to be set',
          atLeastOneRoute: 'At least one route is required',
          atLeastTwoRouteLegs: 'At least two route legs are required',
          duplicateRouteName: 'Duplicate Route Name not allowed',
          deletedLocation:
            'This location in card is no longer exists, please update accordingly',
          minNumber: '{{name}} must be greater than or equal to {{len}}.',
          noDecimals: "{{name}} can't have decimals.",
          isRequired: '{{name}} is required',
          isEmpty: '{{name}} is empty.',
          onlyNumbers: '{{name}} should only contain numbers',
          onlyAlphaNumeric: '{{name}} should be AlphaNumeric [without space]',
          fileTooBig: 'File too large',
          onlyPDF: 'Only PDF supported',
          confirmation: 'Are you sure you want to {{action}} {{item}}?',
          couldNotFind: "Couldn't find the {{item}} you were looking for",
          isRequiredIf: "{{name}} required when {{other}} is set'",
          copyRouteAlert: 'Where do you want to copy the route {{item}} ?',
          lastRoute: 'Tour Template must have at least one route!',
          lastCustomerLocation:
            'Customer deviation must have at least one location!',
          legLocationRequired: 'Route leg location required',
          deleteConfirmation: 'Are you sure you want to delete ',
          unlockConfirmation: 'Are you sure you want to unlock ',
          unlockWarning:
            'This will refresh the route page and unsaved changes may get discarded!',
          fieldPositive: '{{name}} must be a positive number',
          noRemainingGoods: 'Remaining goods data not found!',
          noTerminalSelected: 'No terminal is selected!',
          selectedTerminals: 'Selected Terminals:',
          selectClassification: 'Select Classification',
          noLegRoutesData: 'No routes data found for selected date range!',
          loadingApi: 'Loading...',
          routesAllTerminals:
            'Routes - Avg. Filled factors + Total PPLs [All Terminals]',
          totalRoutesSuccess: 'Total {{total}} routes created successfully!',
          totalRoutesDeleted: 'Total {{total}} routes deleted successfully!',
          noDataForAll: 'No data found for all terminals!',
          noDataAvailable: 'No data available',
          routesOneHighLow: 'Routes - Filled factors [Lowest & Highest]',
          uploadSuccess: 'Uploaded successfully!',
          plannedRoutesSuccess: 'Routes created successfully!',
          plannedRoutesErrorDate:
            'Please check exception dates, seems it is same as date range!',
          plannedRoutesErrorRange:
            'Date range is too large, please choose range within 3 months!',
          uploadError: 'Error while uploading!',
          updatingRoute: 'Updating route...',
          pingBy: 'Edit request - Ping by',
          repeatDatesWithinRange:
            'Selected dates must fall within the chosen start and end date',
          routeUpdated: 'Route updated!',
          routeSameContent: 'Already saved - No changes found!',
          routeLeaveConfirmation:
            'You may have unsaved changes, Are you sure you want to leave?',
          checklistLeaveConfirmation:
            "[If you are sure to leave this page, please 'Cancel' this prompt and leave safely after clicking on 'Unlock All' button] You may have unsaved changes, Are you sure you want to leave anyway?",
          limitedQtyInfoTitle: 'Limited Quantity - Info',
          unNumber: 'Enter UN Number',
          unNumberLength: 'UN Number must be of 4 digit',
          un4DigitNumber: '4 Digit UN Number',
          alertImportSuccess: 'Imported {{count}} {{type}} successfully!',
          importFailed: 'Server error, Import failed!',
          noDataInExcelImport: 'No data imported, Duplicate rows!',
          invalidExcelFormat: 'Invalid file template / card type!',
          emptyRowInSheet: 'Seems empty file, No data found to import!',
          improperFileForImport:
            'Please make sure file extension is .xlsx and size is less than {{sizeInMB}} MB',
          improperImageFileForUpload:
            'Please select Image file and size should be less than {{sizeInMB}} MB',
          improperDocFileForUpload:
            'Please select proper file and size should be less than {{sizeInMB}} MB',
          limitedQtyInfo:
            'The limited quantity is the maximum quantity per inner packaging or article for the transport of dangerous goods in limited quantities and is subject to these regulations:\n' +
            '  > The dangerous goods must not exceed the Limited Quantity defined for the UN number.\n' +
            '  > The dangerous goods must be packed in an inner and outer packaging.\n' +
            '  > The packaging does not have to have design approval, but must protect the goods from damage during transport.\n' +
            '  > The total gross mass of the package must not exceed 30 kg, the total gross mass of trays must not exceed 20 kg.\n' +
            '  > The outer packaging must bear a marking for limited quantities.\n' +
            '  > The transport document must contain the entry “Dangerous goods in limited quantity + gross weight”.\n' +
            '  > The driver must be trained in accordance with the ADR 1.3 dangerous goods regulations.\n',
          updateError:
            'Entered seal number already exists, please enter another seal number',
          loadingListError:
            'Leg with load is not found, please check your route',
          loadingListServerError:
            'Failed to fetch the loading list. try again!',
          timeFormatError: 'Please enter proper time',
          invalidTimeRange: 'Invalid time range',
          maxRangeDiff: 'Max range diff. {{days}} days',
          required: 'Required',
          plsSelectTerminal: 'Please select a terminal to view routes data',
          selectTerminal: 'Please select terminal to view info',
          noShipmentFound:
            'No shipment found for current terminal, Try changing the date.',
          wrongGridHeader: '* <Total> is not allowed in RowHeader name',
          noNextLegAvailable: 'CMR is not Available for this route',
          loadPPLIsAbove100: "PPL factor can't be more than 100% ",
          noCMRFound: 'CMR is not available for this route',
          atLeastOneFile: 'At least one file must be added',
          noFilesAttached: 'No file is attached - Be adviced!',
          invalidEmailWithComma:
            'Email string contains multiple commas without valid emails between them.',
          validEmail: 'All emails are valid',
          invalidEmail: 'Invalid Email',
          invalidStartDate: 'Invalid startDate',
          invlaidDateTime: 'Date time is either Invalid or Blank',
          endWithComma: 'Email string ends with a comma',
          tooManyEmails: 'Maximum 10 Emails user can enter for Manual Alerts',
          noLoadingListAvailable: 'No Loadinglist Available!',
          maxDateRange:
            'Maximum one day range allowed. And StartDate must start after {{nthDay}}th day from now.',
          holidayAltDateMessage:
            'Routes for the date [{{altDateMessage}}] will be now genertaed on',
          invalidNumber: 'Please enter a valid number',
          positiveNumber: 'Must be a positive number',
          maxNumber: 'Max allowed value is {{max}}',
        },
        button: {
          copy: 'Copy {{item}}',
          create: 'Create {{item}}',
          creating: 'Creating {{item}}',
          change: 'Change {{item}}',
          update: 'Update {{item}}',
          updating: 'Updating {{item}}',
          edit: 'Edit {{item}}',
          add: 'Add {{item}}',
          save: 'Save {{item}}',
          remove: 'Remove {{item}}',
          get: 'Get {{item}}',
          cancel: 'Cancel',
          export: 'Export',
          view: 'View {{item}}',
          download: 'Download {{item}}',
          back: 'Back',
          close: 'Close',
          confirmAndCopy: 'Confirm and Copy',
          confirmAndLink: 'Confirm and Link',
          closeItem: 'Close {{item}}',
          delete: 'Delete {{item}}',
          deleting: 'Deleting',
          continue: 'Continue',
          logOut: 'Log out',
          ok: 'OK',
          yes: 'Yes',
          saveChanges: 'Save changes',
          unlockAll: 'Unlock all',
          viewHighLow: 'View Highest and Lowest',
          viewTFT: 'View TFT Grid',
          tftOverview: 'TFT OVERVIEW',
          allCancelled: 'All Cancelled',
          onlySporadic: 'View Sporadic',
          unlink: 'Unlink',
          hide: 'Hide',
        },
        resource: {
          accounts: {
            plural: 'Accounts',
            lowercased: 'account',
          },
          associatedRoutes: {
            lowercased: 'associated routes',
            capitalized: 'Associated Routes',
            active: 'Associated Routes (Active)',
          },
          bookmark: {
            lowercased: 'bookmark',
            capitalized: 'Bookmark',
            plural: 'Bookmarks',
          },
          card: {
            lowercased: 'card',
            capitalized: 'Card',
            plural: 'Cards',
          },
          checkpoint: {
            lowercased: 'checkpoint',
            capitalized: 'Checkpoint',
            plural: 'Checkpoints',
          },
          checklistRoute: {
            capitalized: 'Checklist route',
            plural: 'Checklist routes',
          },
          cmr: {
            lowercased: 'cmr',
            capitalized: 'CMR',
            plural: 'CMRs',
          },
          contact: {
            lowercased: 'contact',
            capitalized: 'Contact',
            plural: 'Contacts',
          },
          costAllocation: {
            lowercased: 'cost allocation',
            capitalized: 'Cost Allocation',
            plural: 'Cost Allocations',
          },
          costDetails: {
            lowercased: 'cost details',
            capitalized: 'Cost Details',
          },
          customer: {
            lowercased: 'customer',
            capitalized: 'Customer',
            plural: 'Customers',
          },
          customs: {
            lowercased: 'customs',
            capitalized: 'Customs',
          },
          deviation: {
            lowercased: 'deviation',
            capitalized: 'Deviation',
            plural: 'Deviations',
          },
          documentFile: {
            lowercased: 'file',
            capitalized: 'File',
            plural: 'Files',
          },
          dispatchedRoute: {
            lowercased: 'dispatched route',
            capitalized: 'Dispatched route',
            plural: 'Routes',
          },
          extraInbound: {
            capitalized: 'Extra Inbound',
          },
          extraOutbound: {
            capitalized: 'Extra Outbound',
          },
          grid: {
            capitalized: 'Add Grid',
          },
          productionDate: {
            lowercased: '(production date)',
          },
          noInboundOutbound: {
            capitalized: 'No Inbound / Outbound sporadic routes for this date',
          },
          noInbound: {
            capitalized: 'No Inbound sporadic routes for this date',
          },
          noOutbound: {
            capitalized: 'No Outbound sporadic routes for this date',
          },
          noInfoAdded: {
            capitalized: 'No Information added!',
          },
          noBoxAdded: {
            capitalized: 'No Box to display!',
          },
          noGridAdded: {
            capitalized: 'No Grid to display!',
          },
          notDispatched: {
            capitalized: '{{item}}(Not Dispatched)',
          },
          dateManagement: {
            capitalized: 'Date Management',
            notice:
              'Only applicable to Fixed tourRoutes, Single/Multiple Sporadic will be still generated.',
          },
          legDetails: {
            capitalized: 'Leg Details',
          },
          loadingList: {
            lowercased: 'loading list',
            capitalized: 'Loading list',
            plural: `Loading list's`,
          },
          loadingListOverview: {
            lowercased: 'loading list overview',
            capitalized: 'Loading list overview',
          },
          unloadingList: {
            lowercased: 'unloading list',
            capitalized: 'Unloading list',
            plural: `Unloading list's`,
          },
          loadingListItem: {
            lowercased: 'loading list item',
            capitalized: 'Loading list Item',
            plural: `Loading list's items`,
          },
          location: {
            lowercased: 'location',
            capitalized: 'Location',
            plural: 'Locations',
          },
          locationList: {
            lowercased: 'location list',
            capitalized: 'Location List',
            plural: 'Locations List',
          },
          order: {
            lowercased: 'order',
            capitalized: 'Order',
            plural: 'Orders',
          },
          peakDebit: {
            lowercased: 'peak debit',
            capitalized: 'Peak debit',
          },
          peakPlanning: {
            lowercased: 'peak planning',
            capitalized: 'Peak planning',
          },
          route: {
            lowercased: 'route',
            capitalized: 'Route',
            plural: 'Routes',
          },
          routeFtl: {
            lowercased: 'FTL',
            capitalized: 'FTL',
            plural: 'FTL',
          },
          routeLeg: {
            lowercased: 'leg',
            capitalized: 'Leg',
            plural: 'Legs',
          },
          shipment: {
            lowercased: 'Shipment',
            template: 'Template',
          },
          newShipment: {
            lowercased: 'Shipment 2.0',
            template: 'Shipment 2.0 Template',
          },
          oldShipment: {
            lowercased: 'Shipment [Old]',
          },
          sporadicRoute: {
            lowercased: 'sporadic route',
            capitalized: 'Sporadic route',
            plural: 'Sporadic routes',
            abbreviation: 'SR',
            add: 'Add Sporadic Route',
          },
          plannedRoute: {
            lowercased: 'planned sporadic routes',
            capitalized: 'Planned Sporadic routes',
            plural: 'Planned routes',
          },
          all: {
            lowercased: 'all',
            capitalized: 'All',
            plural: 'All',
          },
          subcontractor: {
            lowercased: 'subcontractor',
            capitalized: 'Subcontractor',
            plural: 'Subcontractors',
          },
          identity: {
            capitalized: 'Identity',
          },
          template: {
            lowercased: 'template',
            capitalized: 'Template',
            plural: 'Templates',
          },
          terminal: {
            lowercased: 'terminal',
            capitalized: 'Terminal',
            plural: 'Terminals',
          },
          tour: {
            lowercased: 'tour',
            capitalized: 'Tour',
            plural: 'Tours',
          },
          reportToTerminal: {
            capitalized: 'Report to terminal',
          },
          viewReportFromTraffic: {
            capitalized: 'Report from traffic',
          },
          reportFor: {
            capitalized: 'Report from traffic for ',
          },
          reportNoData: {
            inOut: '-- No Inbound/Outbound routes found for selected date! --',
            in: '-- No Inbound routes found for selected date! --',
            out: '-- No Outbound routes found for selected date! --',
          },
          reportRouteData: 'No routes data found for selected date range',
          tourSchedule: {
            lowercased: 'tour schedule',
            capitalized: 'Tour schedule',
            plural: 'Tour schedules',
          },
          traffic: {
            lowercased: 'traffic',
            capitalized: 'Traffic',
          },
          valueBoxes: {
            capitalized: 'VALUE BOXES',
          },
          previousStop: {
            capitalized: 'Previous stop',
          },
          nextStop: {
            capitalized: 'Next stop',
          },
          viewLoadingList: {
            capitalized: 'Loading List',
          },
          loadCarrierDetails: {
            capitalized: 'Load Carrier Details',
          },
          routeDetails: {
            capitalized: 'Route Details',
          },
        },
        validationError: {
          string: {
            min: 'Needs to be at least ${min} characters',
            required: 'Is required',
          },
          number: {
            min: 'Value needs to be more than ${min}',
            required: 'Is required',
          },
        },
        attributeGrouping: {
          invoice: 'Invoice',
          driver: 'Driver',
          agreement: 'Agreement',
          note: 'Note',
          dates: 'Dates',
        },
        enums: {
          deviationCause: {
            LeftoverCargo: 'Leftover cargo',
            TrafficIssues: 'Traffic issues',
            DelayedFerry: 'Delayed ferry',
            ForceMajeure: 'Force Majeure',
            TechnicalIssueOnEquipmentOrTruck:
              'Technical issue on equipment or truck',
            CustomsIssues: 'Customs issues',
            LateDeparture: 'Late departure',
            PoliceControl: 'Police control',
            Other: 'Other',
          },
          deviationFault: {
            Customer: 'Customer',
            Terminal: 'Terminal',
            Subcontractor: 'Subcontractor',
            ExternalPart: 'External part',
            BringCustoms: 'Bring (Customs)',
            WeatherConditions: 'Weather conditions',
            AddedFromTerminal: 'Added from terminal',
            FaultFromTerminal: 'Bring (Terminal)',
            Other: 'Other',
          },
          dangerousGoodsClass: {
            Explosives: 'Explosives',
            Gases: 'Gases',
            FlammableLiquids: 'Flammable Liquids',
            FlammableSolids: 'Flammable Solids',
            OxidizingSubstancesandOrganicPeroxides:
              'Oxidizing Substances and Organic Peroxides',
            ToxicandInfectiousSubstances: 'Toxic and Infectious Substances',
            RadioactiveMaterial: 'Radioactive Material',
            CorrosiveSubstances: 'Corrosive Substances',
            MiscellaneousDangerousSubstancesandArticles:
              'Miscellaneous Dangerous Substances and Articles',
          },
          remainingGoodsReasonClass: {
            LackOfDocuments: 'Lack of Documents',
            LackOfCapacity: 'Lack of Capacity',
            LateArrivalToTerminal: 'Late Arrival to Terminal',
            DamagedItems: 'Damaged Items',
            Other: 'Other',
            LeftoverCargo: 'Leftover cargo',
            TrafficIssues: 'Traffic issues',
            DelayedFerry: 'Delayed ferry',
            TechnicalIssueOnEquipmentOrTruck:
              'Technical issue on equipment or truck',
            CustomsIssues: 'Customs issues',
            LateDeparture: 'Late departure',
            PoliceControl: 'Police control',
            MissingEdi: 'Missing EDI',
            MissingPallets: 'Missing Pallets',
            LateProduction: 'Late Production',
            PlannedOnNextDayRoutes: 'Planned on next day Routes',
            DangerousGoods: 'Dangerous goods',
            RedChannel: 'Red channel',
          },
          tourRouteTemplate: {
            SingleSporadic: 'Single Sporadic',
            MultipleSporadic: 'Multiple Sporadic',
            Fixed: 'Fixed',
            Old: 'Old',
          },
          customsProcedure: {
            T1: 'T1',
            T2: 'T2',
            TVINN: 'TVINN',
            VOEC: 'VOEC',
            LETTERVOLUME: 'LETTER VOLUME',
            DIGITOLL: 'DIGITOLL',
            DIGITOLLEXTERN: 'DIGITOLL EXTERN',
            DIGITOLLVOEC: 'DIGITOLL VOEC',
          },
          templateType: {
            SINGLE_ROUTE: 'Single Route',
            ROUND_TOUR: 'Round Tour',
            MULTIPLE_ROUTES: 'Multiple Routes',
          },
          RouteType: {
            MultipleSporadic: 'Multiple Sporadic',
            Sporadic: 'Sporadic',
            Fixed: 'Fixed',
            SingleSporadic: 'Single Sporadic',
            Single: 'Single Sporadic',
          },
          legType: {
            Load: 'Load',
            Unload: 'Unload',
            Checkpoint: 'Checkpoint',
          },
          scheduleRepeatType: {
            DAYS: 'Days',
            WEEKS: 'Weeks',
            MONTHS: 'Months',
            YEARS: 'Years',
          },
          country: {
            norway: 'Norway',
            sweden: 'Sweden',
            denmark: 'Denmark',
            finland: 'Finland',
            netherland: 'Netherlands',
          },
          department: {
            linehaul: 'LineHaul',
            direct: 'Direct',
            terminal: 'Terminal',
            other: 'Other',
          },
          weekNum: {
            FIRST: 'FIRST',
            SECOND: 'SECOND',
            THIRD: 'THIRD',
            FOURTH: 'FOURTH',
            FIFTH: 'FIFTH',
            LAST: 'LAST',
          },
        },
        attributes: {
          addNew: 'Add New',
          viewList: 'View List',
          alert: 'Alert',
          active: 'Active',
          accountNumber: 'Account number',
          actualCapacity: 'Capacity',
          addNewContact: 'Add new contact',
          address: 'Address',
          additionalCost: 'Additional Cost',
          additionalDiscount: 'Additional Discount',
          addLeg: 'Add Leg',
          addTruck: 'Add Truck',
          addTruckLoading: 'truck - Loading',
          addTruckUnloading: 'truck - Unloading',
          addUnplannedRoute: 'Add Unplanned Route',
          addDate: 'Add date to create shipment',
          lastDays: 'Last {{days}} Days',
          adr: 'ADR',
          agreedPrice: 'Agreed price',
          agreement: 'Agreement',
          agreementNumber: 'Agreement number',
          agreementPdf: 'Agreement pdf',
          and: 'and',
          arrivalCity: 'Arrival city',
          arrivalCountry: 'Arrival country',
          arrivalDate: 'Arrival date',
          arrivalLocation: 'Arrival location',
          arrivalTime: 'ArrivalTime',
          assigned: 'Assigned',
          ansvBefraktare: 'AnsvBefraktare',
          assignedStatus: 'Assigned Status',
          available: 'Available',
          firstLegArrivalTime: 'First leg arrival time ',
          firstLegDepartTIme: 'First leg departure time',
          lastLegArrivalTime: 'Last leg arrival time',
          lastLegDepartTime: 'Last leg departure time',
          arrivalTimeAbbreviated: 'A.T.',
          actualArrivalTime: 'ArrivalTime',
          actualArrTime: 'Actual arrival time',
          amount: 'Amount',
          allGroups: 'All groups',
          alternateGenerateDate: 'Alternate Date',
          booked: 'Booked',
          bookedPPL: 'Booked PPL',
          borderCrossing: 'Border crossing',
          box: 'Box',
          boxName: 'Box name',
          bringCost: 'Bring Cost',
          tag: 'Tag',
          tagName: 'Tag name',
          capacity: 'Capacity',
          capacityAbbreviated: 'CAP',
          car: {
            upperCased: 'CAR',
            lowerCased: 'car',
            capitalized: 'Car',
          },
          carRegistrationNumber: 'Car Registration Number',
          registrationNumber: 'Registration Number',
          routeCarRegNumber: 'Car Registration Number',
          cause: 'Cause',
          causeReason: 'Cause/Reason',
          city: 'City',
          cdc: 'CDC',
          cmr: 'CMR',
          chartTerminalWise: 'Terminalwise chart',
          chartCustomerWise: 'Customerwise chart',
          checkListRoutesTitle: 'Checklist - Dispatched Routes',
          checkLists: 'Checklist',
          checkDangerGood: 'Check DangerGoods?',
          clearedFromCustom: 'Export cleared',
          clearedFromCustomImport: 'Import cleared',
          clickToDownload: 'Click here to download',
          clickToDelete: 'Click here to delete',
          comingSoon: 'Coming Soon',
          comment: 'Comment',
          compactRowHeight: 'Compact Row Height',
          contactType: 'Contact type',
          consequence: 'Consequence',
          copyRoute: 'Copy route',
          copyToOtherEmptyRows: 'Copy to other rows',
          cost: 'Cost',
          costOverview: 'COST OVERVIEW',
          costType: 'Cost Type',
          costTags: 'Cost Tags',
          country: 'Country',
          createdBy: 'Creator',
          currency: {
            upperCased: 'CURRENCY',
            lowerCased: 'currency',
            capitalized: 'Currency',
          },
          ftlCurrency: 'FTL currency',
          customer: 'Customer',
          customsProcedure: 'Customs procedure',
          customerCost: 'Customer cost',
          customerCurrency: 'Customer cost currency',
          customerId: 'Customer',
          customerNumber: 'Customer number',
          customerReference: 'Customer reference',
          customerCheck: 'Need of check from customer',
          customVOECId: 'customVOECId',
          customInvoiceNo: 'customInvoiceNo',
          customMrnNo: 'customMrnNo',
          customWaybillNo: 'customWaybillNo',
          customCmrNo: 'customCmrNo',
          customNote: 'customNote',
          connectedNB: 'connectedNB',
          copyDriverPlateInfo: 'Copy below details to each leg',
          currentTour: 'Current tour',
          cmrNo: 'CMR No:',
          connectedNo: 'Connected No:',
          dangerGoodFound: 'Some/One route here, contains Dangerous goods',
          dangerGoodNotFound: 'No Dangerous goods found in any Routes',
          date: 'Date',
          day: 'Day',
          days: 'Days',
          debit: 'Debit',
          debitCount: 'Debit count',
          deleteSelected: 'Delete selected',
          deliveryDate: 'Delivery date',
          department: 'Department',
          departureCity: 'Departure city',
          departureCountry: 'Departure country',
          departureDate: 'Departure date',
          departureLocation: 'Departure location',
          departureTime: 'DepartureTime',
          departureTimeAbbreviated: 'D.T.',
          destinationCountry: 'Destination country',
          deviationType: 'Deviation type',
          deviationApplicableDate: 'Date',
          difference: 'Difference',
          dispatcherId: 'Dispatcher',
          dispatchv2: 'Dispatch V2',
          discount: 'Discount',
          dividePriceEqually: 'Divide price equally',
          dontHaveTemplate: "Don't have template file?",
          driverInfo: 'DriverInfo',
          driverRead: 'DriverInfo - ReadOnly',
          driverName: 'Driver name',
          driverPhoneNumber: 'Driver phone number',
          docking: 'Docking',
          dynamicRowHeight: 'Dynamic Row Height',
          exit: 'Exit (esc)',
          fullscreen: 'Fullscreen (ctrl + f)',
          reason: 'reason',
          routeDriverName: 'Driver Name',
          routeDriverPhoneNumber: 'Driver PhoneNumber',
          endTime: 'Select end time for filter',
          email: 'Email',
          emailSent: 'Email sent',
          estDock: 'Est. Dock',
          estUndock: 'Est. Undock',
          externalNote: 'External Note',
          exportReport: 'Production Report',
          endCreateDate: 'End create date',
          endExceptionDate: 'End exception date',
          endDate: 'End date',
          failConfigMessage: 'Cannot save configuration',
          fault: 'Source',
          faultLocationId: 'From location',
          fetchProductionGroup: 'Production groups?',
          file: 'File',
          fileTagIds: 'File tags',
          filterGroup: 'Filter Type',
          trafficType: 'Traffic Type',
          ftlInvoiceNote: 'FTL invoice note',
          filteredRowsCSV: 'filtered rows csv',
          forTransportDate: 'For TransportationDate',
          frequency: 'Frequency',
          fromCountry: 'From country',
          fromLocationId: 'From Location',
          fromToToCountry: 'From-To country',
          filter: 'Filter',
          gateNumber: 'Gate Number',
          generateByDateRange: 'Generate By Selecting Date Range:',
          getExcel: 'Get Excel',
          getFilteredExcel: 'Get Filtered Excel',
          grid: 'Grid',
          gridNameLabel: 'Enter name (max. 15 char)',
          gridRowsLabel: 'Enter number of rows',
          gridColumnsLabel: 'Enter maximum 10 columns',
          hiddenOrders: 'Hidden orders',
          visibleOrders: 'All visibile orders',
          nexusOrders: 'Nexus orders',
          phOrders: 'PH orders',
          initPrint: 'Initializing Print',
          rowHeader: 'Add Row Headers (maximum 15 characters)',
          columnHeader: 'Add Column Headers (maximum 10 characters)',
          groupingTag: 'Group tag',
          goodsInfo: 'Goods Info -',
          customsInfo: 'Customs Info',
          terminalInfo: 'Terminal Info',
          performAction: 'Perform action',
          copyAction: 'Copy Action',
          hideAction: 'Hide',
          deleteAction: 'Delete',
          mixedUnits: 'Mixed Units',
          name: 'Name',
          nonArrival: 'Non-arrival',
          nameWithResource: '{{item}} Name',
          numberOfCopies: 'Number of Copies',
          numberOfCopiesHelp: 'Enter a number between {{min}} and {{max}}',
          fromTerminal: 'From location',
          fuel: 'Fuel',
          hasExceptionDates: 'Add exception dates',
          chooseFromCalendar: 'Choose from Calendar',
          id: 'Id',
          includedKpi: 'Included KPI',
          includedPrice: 'Included Price',
          info: 'Info',
          legOverview: 'Leg Overview',
          legSpecificCost: 'Leg Specific Cost',
          routeGridInfo:
            'Info: click save config button to save table configuration',
          originalStartDate: 'Original Start Date',
          orderIsLinked: 'Linked from Shipment, Not editable.',
          invoiceNote: 'Invoice note',
          invoiceNumber: 'Invoice number',
          turnummer: 'turnummer',
          togref: 'togref',
          bpx: 'bpx',
          pri03: 'pri03',
          pri49: 'pri49',
          upri03: 'upri03',
          upri49: 'upri49',
          parti: 'parti',
          brev: 'brev',
          pru: 'pru',
          pip: 'pip',
          singleSubcon: 'Single SubCon',
          tom: 'tom',
          tripGen: 'Trip Gen',
          rutekode: 'Rutekode',
          searchLocation: 'Search location',
          selectLocation: 'Select location',
          received: 'received',
          receivedByTraffic: 'Received By Traffic',
          timeReceivedByTraffic: 'Traffic Receiver Time',
          typeToSearchLocations: 'Type to search locations',
          nameReceivedByTraffic: 'Traffic Receiver Name',
          noLocationsFound: 'No locations found',
          firstLegDate: 'First leg date',
          lastLegDate: 'Last leg date',
          firstLegTerminalName: 'First leg terminal',
          lastLegTerminalName: 'Last leg terminal',
          inCarLoad: 'Load in CAR',
          inTrailerLoad: 'Load in TRAILER',
          isLoadingInCar: 'Load in CAR',
          isLoadingInTrailer: 'Loading In Trailer',
          trainNumber: 'Train Number',
          trainReference: 'Train Reference',
          containerId: 'Container ID',
          transportType: 'Transport Type',
          inneholdsbeskrivelse: 'Inneholdsbeskrivelse',
          kilometer: 'KM',
          lastUpdatedBy: 'Last updated by',
          licensePlate: 'License plate',
          licensePlateAndNote: 'License plate & Note',
          limitedQty: 'Limited Quantity',
          LC1: 'LC1',
          lc1Description: 'LC1 Description',
          LC2: 'LC2',
          lc2Description: 'LC2 Description',
          LC3: 'LC3',
          lc3Description: 'LC3 Description',
          lcDetails: 'LC Details',
          load: 'Load',
          loaded: 'Loaded',
          loadCarrier: 'Load Carrier',
          loadEnd: 'Load End',
          loadingLocation: 'Loading location',
          loadStart: 'Load start',
          location: 'Location',
          locationId: 'Location',
          locationCode: 'Location Code',
          locationName: 'Location name',
          logisticPerson: 'Logistic person',
          logisticPersonName: 'Logistic person name',
          locationType: 'Location Type',
          headedTerminalId: 'Terminal',
          legType: 'Leg Type',
          loadingListOverview: 'Loading List Overview',
          multipleCustomers: 'Multiple Customers',
          myPlannedRoutes: 'My Planned Routes',
          mrnNo: 'MRN No:',
          noItemsToUnload: 'No items to unload',
          noLoadingListAdded: 'No Loading List added yet!',
          noLoadingListData: 'No Loading List data found',
          note: 'Note',
          newCustomer: 'New customer',
          operationType: 'Operation Type',
          otherTour: 'Other tour',
          otherReason: 'Other reason',
          onDay: 'On Day',
          internalNote: 'Internal note',
          noteWithResource: '{{resource}} Note',
          numbersGrid:
            'Create Numbers Grid with Total row (Row count must > 1)',
          reset: 'Reset',
          saveLegs: 'Save Leg(s)',
          startEndDateTime: 'Start DateTime - End DateTime',
          selectAtleastOneLocation: 'Select at least one location',
          successMsg: 'Successfully Done',
          successSavedMsg: 'Successfully saved',
          trainCompany: 'Train Company',
          receivedBy: 'receivedBy',
          receivedStatus: 'Received Status',
          errorWhileSavingChangesMsg: 'Error while saving the changes',
          errorWhileUpdatingPosition: 'Error while updating the leg position',
          errorWhileUpdatingCostAllocation:
            'Error while updating the cost allocation',
          errorLegNotFound: 'Leg not found',
          failedToDeleteTemplate: 'Failed to delete template',
          invalidRouteId: 'Invalid route ID.',
          missingDataKey:
            'Missing data key. Please navigate from the template page.',
          notAbleToDeleteLeg: 'Not able to delete leg',
          text: 'Text',
          terminal: 'Terminal',
          terminalCleared: 'Cleared from Terminal',
          terminalNotCleared: 'Deviation from Terminal',
          trailerRegistrationNumber: 'Trailer Registration Number',
          timeWhenAssigned: 'timeWhenAssigned',
          timeWhenReceived: 'Time When Received',
          total: 'Total',
          totalKM: 'Total KM',
          totalLegs: 'Total Legs',
          trainStation: 'Train station',
          loadLegs: 'Load Legs',
          noTerminalsFound: 'No terminals found',
          unloadLegs: 'Unload Legs',
          repeatType: 'Repeat type',
          repeatEvery: 'Repeat every',
          repeatData: 'Repeat data',
          routeTrailerRegNumber: 'Trailer Registration Number',
          routeName: 'Route Name',
          refreshGrid: 'Refresh grid',
          tags: 'Tags',
          templateName: 'Template Name',
          templateOverview: 'Template Overview',
          transprtationDate: 'Transport Date',
          title: 'Title',
          toTerminal: 'To location',
          toLocationId: 'To location',
          totalOfEverything: 'Overall Cost ',
          totalBringCost: 'Total BringCost',
          totalNewAgreedPrice: 'New AgreedPrice',
          totalAdditionalCost: 'Total AdditionalCost',
          tourTemplateWarn: `*Updated template data will reflect in 'FixedRoute' from the day after tomorrow`,
          totalRows: 'Total Rows: {{ rowCount }}',
          type: 'Type',
          pastDate: 'ReadOnly due to past date',
          packages: 'Packages',
          pallets: 'Pallets',
          palletSpace: 'Pallet Space',
          percentage: 'Percentage',
          phLocationId: 'PH Location ID',
          phoneNumber: 'Phone number',
          plannedCapacity: 'Planned capacity',
          postalCode: 'Postal code',
          price: 'Price',
          pricePercentage: 'PricePercentage',
          print: 'Print',
          printLoadingLists: 'Print loading lists',
          preparingLoadingLists: 'Preparing loading lists...',
          productionDate: 'Production date',
          productCountry: 'Product country',
          productType: 'Product type',
          productionGroup: 'Production group',
          readOnly: 'Read-only mode',
          receiverLocationId: 'Receiver location',
          RecievedAndHandled: 'Recieved and Handled',
          RecievedNotStarted: 'Recieved not Started',
          reloadLegDetails: 'Please reload leg details',
          reloadLoadingListDetails: 'Please reload loading list details',
          remainingGoods: 'Remaining Goods',
          responsible: 'Responsible',
          responsiblePerson: 'Responsible person',
          replyToInfo: 'Reply to info',
          reportNotUploaded: 'Report yet not uploaded!',
          role: 'Role',
          routeId: 'Route Id',
          routeGroupTag: 'Route Group Tag',
          routeDriverInfo: 'Driver & LicensePlate Info',
          routeOverview: 'Route Overview',
          routesHistory: `Check this to view all routes history, based on selected filters from Grid. You must choose Date range and at least one filter.`,
          routesInHistory: `You must choose Date range and at least one filter in Grid - to fetch routes`,
          history: 'History',
          fetchNow: 'Fetch Now',
          sameDayBoxInfo: `Check this to only see one date in range. 
          Uncheck this if you want to see todays date in End and yesterday's date in End.
          Time will not be affected but end time can not be earlier than start time if 24h Prod. is checked`,
          saveConfigSuccessMessage: 'Configuration saved successfully',
          updateSubcontractorSuccessMessge:
            'Subcontractor details saved successfully',
          updateSubcontractorErrorMessge:
            'Error while saving Subcontractor details. Please try again.',
          sameProdDay: '24h Prod.',
          selectTerminals: 'Select Terminals',
          selectLocations: 'Select Locations',
          salesContact: 'Sales contact',
          salesPerson: 'Sales person',
          salesPersonName: 'Sales person name',
          selfCost: 'Self cost',
          selfCostCurrency: 'Self cost currency',
          selectedDates: 'Selected dates:',
          selectedExcDates: 'Selected Exception dates:',
          quickResponse: 'Select a quick response',
          routeTotals: 'Route Totals',
          senderLocationId: 'Sender location',
          sentPPL: 'Sent PPL',
          showingYourRoutes: 'Showing routes created by you on',
          shipmentNotArrived: 'Shipment not arrived',
          startCreatedDate: 'Start create date',
          startDate: 'Start date',
          startTime: 'Select start time for filter',
          startExceptionDate: 'Start exception date',
          subcontractorId: 'Subcontractor',
          subcontractorLocationId: 'Subcontractor location',
          subcontractorTwoId: 'Other Subcontractor',
          sumDiscount: 'Sum Discount',
          status: 'Status',
          sum: 'Sum',
          templateCreatedSuccessfully: 'Template created successfully',
          toCountry: 'To country',
          totalWeight: 'Total Weight',
          tourIdSuffix: 'Tour Id suffix',
          trailer: {
            upperCased: 'TRAILER',
            lowerCased: 'trailer',
            capitalized: 'Trailer',
          },
          transitDays: 'Transit Days',
          transportDate: 'Transport. date',
          transportationDate: 'Transportation date',
          transportationDateOffset: 'Trans.Date offset',
          unload: 'Unload',
          unloaded: 'Unloaded',
          undocking: 'Undocking',
          unusedCapacity: 'Unused capacity',
          updatedAt: 'Last update date',
          updateErrorOnDeletedLeg: `The leg can't be updated as it was already deleted`,
          errorOnLoadingListAsLegDeleted: `can't add/delete/update loading list as leg was deleted`,
          updateErrorOnLoadingListAsDeleted: `The loading list can't be updated as it was already deleted`,
          utilization: 'Utilization',
          warningMessage: 'Please select one',
          weight: 'Weight',
          weightKg: 'Weight (KG)',
          localMessageCustomers: 'Message to customer(local)',
          englishMessageCustomers: 'English message to customers',
          registeredStatus: 'Registered',
          unregisteredStatus: 'Unregistered',
          kippRegistered: 'Kipp Registered',
          cancelledStatus: 'Cancelled',
          view: 'View',
          viewSporadicRoutes: 'View Sporadic Routes',
          viewPlannedRoutes: 'View Planned Routes',
          viewFilledItemsReport: 'View Filled items report',
          viewRemainingGoodsReport: 'View Remaining goods report',
          partialRegisteredStatus: 'Partially Registered',
          viewBoxAndInfo: 'View Box and Info report',
          warningOfDangerousGoods:
            '- Leg contains dangerous goods, Advice personnel at terminal.',
          tooltipDangerousGoodsIcon: 'Mark/Unmark the goods item as dangerous',
          tooltipDangerousGoodsIconReadOnly: 'Indicates dangerous goods!',
          tooltipEDA: 'Estimated Date of Arrival',
          tooltipETA: 'Estimated Time of Arrival',
          tooltipETD: 'Estimated time of Departure',
          tooltipActualArrivalDate: 'Actual Arrival Date',
          tooltipActualArrivalTime: 'Actual Arrival Time',
          tooltipActualDepartureDate: 'Actual Departure Date',
          tooltipActualDepartureTime: 'Actual Departure Time',
          tooltipLimitedQtyInfo: 'Limited Qty Info',
          tooltipLinkingInfo:
            'Linking is possible only when the shipment date and both the From and To locations are the same.',
          checkList_tft: 'All trucks in TFT checked [Based on date range]',
          checkList_remGoods: 'Documented all remaining goods',
          checkList_vBox: 'All KPIs are filled',
          checkList_info: 'Relevant information have been noted',
          checkList_title: 'Production report - Checklist items',
          uploadNow: 'Upload Now',
          hideRegistered: 'Hide Registered',
          hideKippRegistered: 'Hide Kipp Registered',
          customSearchOn: 'Custom Search is On',
          customSearchOff: 'Custom Search is Off',
          customSearchInfo:
            'Enable this to search for more than five days date range but you have to select atleast one filter.',
          customSearchHint: 'Choose atleast one filter then click on Apply',
          dateRangeLimited: 'Date range limited to {{days}} days',
          endDateAfterStart: 'End date must be after start date',
          pastDateReadOnly: 'Read only due to past date',
          showRegistered: 'Show Registered',
          showKippRegistered: 'Show Kipp Registered',
          sortingInfo:
            'INFO: For multiple column sorting - Press [Ctrl] and than click sort icon of particular column in Grid',
          sortingIconText: 'Sorting tip',
          routesUpdated: 'Routes updated successfully',
          routesUnlocked: 'Routes unlocked successfully',
          readOnlyDueToShipImported:
            'Read only due to one of the orders is linked to route',
          rememberToUnlock: 'Kindly remember to unlock below routes | Total',
          transDate: 'Trans. date',
          group: 'Group',
          unlockRoutesPls:
            'Kindly unlock below routes first to start editing all',
          pingUser: 'Ping user',
          unlockAnyway: 'Unlock anyway',
          un: 'UN-',
          sureToUnlockAll:
            'Are you sure? Kindly make sure you saved all changes before unlocking.',
          wait: 'wait...',
          checkValidation: 'Check validations and try again',
          groupLocked:
            'Locked by Bulk Checklist Page, Only user who has locked can unlock.',
          createNewChecklist: 'Create New Checklist',
          routeIsLocked: 'Can not edit, this route is locked',
          routes: 'Routes',
          routeLockedBySelf: 'Route is locked by: You ',
          tftTitle: 'Truck Fill and Time - Overview',
          customsTFTTitle: 'TFT Overview',
          prodReportTitle: 'Production Report',
          reportRemainingGoods: 'Remaining Goods',
          reportFilledFactors: 'Statistics',
          reportInformation: 'Information',
          frontPage: 'Front Page',
          untilDate: 'Create until',
          viewSporadicOnly: 'View only sporadic legs',
          viewAllLegs: 'View all cancelled legs of both type',
          waybill: 'Waybill:',
          voecId: 'VOEC ID:',
          loadingListNotFound: 'Loading list not added',
          moDoneStatus: 'MoDone Status',
          userNotAuthorized: 'You are not authorized to view this page',
          skipCron: 'Manual entry - Skip Cron Check',
          skipDB: 'Testing - Skip DB Entry',
          weekdays: 'Weekdays',
          recurrence: 'Recurrence',
          repeat: 'Repeat',
          every: 'Every',
          weekends: 'Weekends',
          allDays: 'All days',
          schedule: 'Schedule',
          dateSelectionType: 'Date Selection Type',
          dateRange: 'Date Range',
          multipleDates: 'Multiple Dates',
        },
        country: {
          sweden: 'Sweden',
          denmark: 'Denmark',
          norway: 'Norway',
        },
        countryInitial: {
          sweden: 'SE',
          denmark: 'DK',
          norway: 'NO',
          finland: 'FI',
          netherland: 'NL',
        },
        filter: {
          date: 'Date',
          startDate: 'Start Date',
          endDate: 'End Date',
          inboundDomestic: 'In. Domestic',
          outboundDomestic: 'Out. Domestic',
          inboundImport: 'Import',
          outboundExport: 'Export',

          search: 'Search',
        },
        view: {
          routeView: 'Route View',
          infoView: 'Info View',
          gridView: 'Grid View',
          valueBoxesView: 'Value Boxes View',
        },
        weekDays: {
          mon: 'Mon',
          tue: 'Tue',
          wed: 'Wed',
          thu: 'Thu',
          fri: 'Fri',
          sat: 'Sat',
          sun: 'Sun',
        },
        states: {
          loading: 'loading',
        },
        actions: {
          add: 'Add {{item}}',
          apply: 'Apply',
          collapse: 'Collapse',
          contact: 'Contact',
          save: 'Save',
          deleteTour: 'Delete entire Tour:',
          delTour: 'Delete Tour',
          delShipment: 'delete shipment',
          delLeg: 'Delete Leg',
          deleteLoadingListMessage: 'Loading list is successfully deleted',
          delete: {
            lowercased: 'delete',
            capitalized: 'Delete',
          },
          overrides: {
            lowercased: 'override',
            capitalized: 'Override',
          },
          remove: {
            lowercased: 'remove',
            withItem: 'Remove {{item}}',
          },
          removeBookmark: {
            lowercased: 'remove bookmark of ',
          },
          cancel: 'Cancel',
          copyTour: 'Copy Tour',
          createShipment: 'Create Shipment',
          downloadImage: 'Click to download',
          edit: 'Edit',
          editItem: 'Edit {{item}}',
          expand: 'Expand',
          update: 'Update',
          updateAndExit: 'Update & Exit',
          uploadImage: 'Click to upload',
          view: 'View',
          viewItem: 'View {{item}}',
          viewItemSwitched: '{{item}} view',
          export: 'Export {{item}}',
          import: 'Import {{item}}',
          get: 'Get {{item}}',
          create: {
            lowercased: 'create',
            capitalized: 'Create',
          },
          debit: 'Debit',
          dispatchRoute: 'Manual Dispatch',
          goTo: 'Go to {{item}}',
          goBack: 'Go back',
          open: 'Open',
          ok: 'OK',
          close: 'Close {{item}}',
          download: 'Download {{item}}',
          downloadReport: 'Download Report',
          moveItem: 'Move {{item}} {{direction}}',
          left: 'left',
          right: 'right',
          promote: 'Promote {{item}}',
          demote: 'Demote {{item}}',
          send: 'Send {{item}}',
          unlock: 'Unlock',
          unlockAnyway: 'Unlock Anyway',
          ping: 'Ping',
          refresh: 'Refresh',
          tftOverviewNorway: 'TFT Overview - NO',
          tourId: 'Tour Id is null',
          unlink: 'Un-link',
          managefiles: 'Manage Files',
          schedule: 'Schedule',
          copyDriverDetailsToLegs: 'Copy driver details to Legs',
          hideOrders: 'Hide Orders',
          addCustomerMapping: 'Add Mapping Details',
          changeShipmentDate: 'Change Shipment Date',
          changeTags: 'Change Tags',
          changePrePlannedRoute: 'Change Preplanned Route',
          generateSporadicRoutes: 'Generate Sporadic Routes',
          selectAll: 'Select All',
        },
        feedback: {
          created: '{{item}} created',
          alreadyCreated: '{{item}} already created',
        },
        info: {
          uploadImage: 'Upload Image',
          uploadDocument: 'Upload Document',
          importCardData: 'Import Card Data',
          fileUploadMessage:
            'Upload Excel file [Max size {{maxFileSizeInMB}} MB]',
          imageUploadMessage:
            'Upload image file [Max size {{maxFileSizeInMB}} MB]',
          docUploadMessage:
            'Upload valid document file [Max size {{maxFileSizeInMB}} MB]',
          fileWillBeReplaced:
            '-If you will upload again, existing file will be replaced.',
          fileExistHere: 'One file exist [{{fileName}}] --> ',
          bookmarkedDispatchRoutes: 'Bookmarked Dispatch Routes',
          note: 'Note',
          noReportRecieverContactAvailable:
            'No Report Reciever contact available! would you like to Send Manually?',
          manualDispatchNote:
            'If the route is dispatched on a day that is not selected in the schedule, it will generate as a sporadic route instead of a dispatch.',
          manualDispath: {
            createdSporadic:
              'This route has been dispatched for {{date}} as a sporadic route. Would you like to open it?',
            createdFixed:
              'This route has been dispatched for {{date}}. Would you like to open it?',
            alreadyCreated:
              'This route is already been dispatched for this date. Would you like to open it?',
          },
          enterMultipleEmail: 'Enter multiple emails separated by a comma ,',
          sendManualAlertSuccess: 'Alert has been sent successfully',
          loading: 'Loading, please wait...',
          routeCompleted: 'Route completed',
          readyForDepartureFrom: 'Ready for departure from',
          onRouteFor: 'On Route for',
          arrivedAt: 'Arrived at',
          noLegsListDataInfo: 'No leg data available',
          pleaseSelectTerminalInfo: 'Please select the terminal',
          dateFieldEditInfo:
            'After updating EDA field, date offset field value of upcoming legs will be marked as zero',
        },
        dialog: {
          userConfig:
            'This will remove all setting for tables, such as column width, density, and resetting hidden/visible columns to default, are you sure?',
          deleteBrowserConfigData:
            'This will remove all settings for the current browser tab like cache, cookies. are you sure?',
          location: `Adding a new location will remove the existing location, are you sure?`,
          chooseLocation: 'Choose the location you want to add a debit to',
          email: 'Send Alerts Manually.',
          selectRoutesToGenerate: 'Select Routes to Generate',
          deleteTemplate: {
            title: 'Delete Template',
            message: 'Are you sure you want to delete this template?',
          },
        },
        menu: {
          changeTerminal: 'Change Terminal',
          clearConfig: 'Clear user configuration',
          clearBrowserConfig: 'Clear browser data',
          changeDepartment: 'Change department to',
          collapseTruckSections: 'Collapse truck sections',
        },
        gridColumns: {
          ADR: 'ADR',
          ADRCount: 'ADR Count',
          EDA: 'EDA',
          ETA: 'ETA',
          ETD: 'ETD',
          KG: 'KG',
          KM: 'KM',
          duration: 'Duration (min)',
          PAL: 'PAL',
          PCS: 'PCS',
          PPL: 'PPL',
          activate: 'Activate',
          actualArrivalDate: 'Actual Arrival Date',
          actualArrivalTime: 'Actual Arrival Time',
          actualDepartureDate: 'Actual Departure Date',
          actualDepartureTime: 'Actual Departure Time',
          arrDate: 'Arr. Date',
          arrTime: 'Arr. Time',
          capacity: 'Capacity',
          carCapacity: 'LC1 Capacity',
          carContainerId: 'LC1 Container ID',
          carGate: 'LC1 Gate',
          carId: 'LC1 ID',
          carOperationType: 'LC1 Operation',
          trailerOperationType: 'LC2 Operation',
          checked: 'Checked',
          checkpointDate: 'Checkpoint Date',
          checkpointLocation: 'Checkpoint Location',
          checkpointTime: 'Checkpoint Time',
          classification: 'Classification',
          contactInfo: 'Contact Info',
          containerNumber: 'Container Number',
          copyRoute: 'Copy Route',
          costOfAllRoutes: 'Cost of all routes',
          country: 'Country',
          customer: 'Customer',
          customerORItem: 'Customer/Item',
          delete: 'Delete',
          Date: 'Date',
          depDate: 'Dep. Date',
          depTime: 'Dep. Time',
          description: 'Description',
          dispatcher: 'Dispatcher',
          distanceInKM: 'Distance In KM',
          downloadAgreementPDF: 'Download Agreement pdf',
          driver: 'Driver',
          driverName: 'Driver Name',
          driverPhoneNumber: 'Driver Phone Number',
          driverContact: 'Driver Contact',
          endDate: 'End Date',
          endLocation: 'End Location',
          fromCountryToCountry: 'From Country - To Country',
          fuelType: 'Fuel Type',
          goodsInfo: 'Goods Info',
          hasDangerousGoods: 'Has Dangerous Goods',
          is_loaded: 'Is Loaded?',
          importedFromShipment: 'Imported from Shipment',
          item: 'Item',
          kippResponsible: 'Kipp Responsible',
          kippReceivedBy: 'Kipp Received By',
          kippReceivedTimestamp: 'Kipp Timestamp When Received',
          legNote: 'Leg Note',
          limitedQuantity: 'Limited Quantity',
          loadingListNo: 'Loading List No',
          loadingListType: 'Loading List Type',
          loadingListStatus: 'Loading List Status',
          loadingListNote: 'Loading List Note',
          legTags: 'Leg Tags',
          legType: 'Leg Type',
          loadLocations: 'Load locations',
          location: 'Location',
          locationTag: 'Location Tag',
          locationLoaded: 'Location Loaded',
          locationUnloaded: 'Location Unloaded',
          locationType: 'Location Type',
          moDone: 'MO Done',
          note: 'Note',
          packages: 'Packages',
          pallets: 'Pallets',
          price: 'Price',
          quantity: 'Quantity',
          receivedStatus: 'Received Status',
          registrationNumber: 'Registration Number',
          responsiblePerson: 'Responsible Person',
          routeName: 'Route Name',
          routeNoteInternal: 'Route Note Internal',
          routeNoteExternal: 'Route Note External',
          routeType: 'Route Type',
          routeTag: 'Route Tag',
          rutekode: 'Rutekode',
          sameSubcontractorToAllRoutes: 'Same Subcontractor to all routes',
          schedule: 'Schedule',
          scheduleData: 'Schedule Data',
          startLocation: 'Start Location',
          status: 'Status',
          startDate: 'Start Date',
          subcontractor: 'Subcontractor',
          sum: 'Sum',
          templateName: 'Template Name',
          templateType: 'Template Type',
          templateNote: 'Template Note',
          terminalReceivedBy: 'Terminal Received By',
          terminalReceivedTimestamp: 'Terminal Timestamp When Received',
          time: 'Time',
          tourTags: 'Tour Tags',
          trailerCapacity: 'LC2 Capacity',
          trailerContainerId: 'LC2 Container ID',
          trailerGate: 'LC2 Gate',
          trailerId: 'LC2 ID',
          transportDate: 'Transport Date',
          transportType: 'Transport Type',
          transportationDateOffset: 'Date Offset',
          type: 'Type',
          unloadLocations: 'Unload locations',
          unNumber: 'UN Number',
          viewAgreementPDF: 'View Agreement pdf',
          oldViewTemplate: 'Old - View Template',
          newViewTemplate: 'New - View Template',
          volume: 'Volume',
          wayBillNo: 'Way Bill No',
          weight: 'Weight',
          weightInKG: 'Weight (In KGs)',
        },
        quickResponse: {
          ok: 'OK!',
          weAreLooking: 'Vi tittar på det',
          thankYou: 'Tack!',
        },
        errors: {
          failedToPrintLoadingLists:
            'Unable to print the selected loading lists. Please try again.',
          loadingListPopupBlocked:
            'Allow popups for Nexus to print loading lists.',
          failedToLoadTerminals: 'Failed to load terminals',
        },
      },
    },
  },
});

export { i18n };
